module.exports = "pegasus/assets/test-fixture-car-back.jpg";